import { c as _c } from "react/compiler-runtime";
import { throttle } from '@cc-shopping/utils/function/throttle';
import { type RefObject, useEffect } from 'react';
type UseCustomStickyElementParams = {
  containerRef?: RefObject<HTMLElement | null>;
  enabled?: boolean;
  offsetBottom?: number;
  offsetTop?: number;
  targetRef: RefObject<HTMLElement | null>;
  targetTop?: number;
};
export function useCustomStickyElement(t0) {
  const $ = _c(8);
  const {
    containerRef,
    enabled: t1,
    offsetBottom: t2,
    offsetTop: t3,
    targetRef,
    targetTop: t4
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const offsetBottom = t2 === undefined ? 0 : t2;
  const offsetTop = t3 === undefined ? 0 : t3;
  const targetTop = t4 === undefined ? 0 : t4;
  let t5;
  let t6;
  if ($[0] !== containerRef || $[1] !== enabled || $[2] !== offsetBottom || $[3] !== offsetTop || $[4] !== targetRef || $[5] !== targetTop) {
    t5 = () => {
      if (!containerRef || !enabled || !targetRef.current || !containerRef.current) {
        return;
      }
      const container = containerRef.current;
      const target = targetRef.current;
      const handleScroll = () => {
        if (!target || !container) {
          return;
        }
        const targetHeight = target.clientHeight;
        const rect = container.getBoundingClientRect();
        const containerTop = rect.top + window.scrollY;
        const containerBottom = rect.bottom + window.scrollY;
        const scrollTop = window.scrollY;
        if (scrollTop >= containerTop + offsetTop && scrollTop < containerBottom) {
          const top = Math.min(containerBottom - targetHeight - containerTop - offsetBottom, scrollTop - containerTop - offsetTop + targetTop);
          target.style.top = `${top}px`;
          target.toggleAttribute("isStuck", true);
        } else {
          target.style.top = targetTop ? `${targetTop}px` : "initial";
          target.toggleAttribute("isStuck", false);
        }
      };
      const throttledHandleScroll = throttle(handleScroll, 0);
      window.addEventListener("scroll", throttledHandleScroll);
      window.addEventListener("resize", throttledHandleScroll);
      return () => {
        window.removeEventListener("scroll", throttledHandleScroll);
        window.removeEventListener("resize", throttledHandleScroll);
      };
    };
    t6 = [enabled, offsetTop, targetRef, targetTop, containerRef, offsetBottom];
    $[0] = containerRef;
    $[1] = enabled;
    $[2] = offsetBottom;
    $[3] = offsetTop;
    $[4] = targetRef;
    $[5] = targetTop;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
}